







































































































import { Component, Prop, VModel } from 'vue-property-decorator'

import { PropertyFieldType, PropertyGroup } from '../../../../BotProperties/components/Properties/types'
import { isPropertyEditable } from '../../../../BotProperties/utils'
import { UserProfile, UserProfileProperties, UserProfileProperty } from '../../../../BotUsers/components/Users/types'
import { UseFields } from '../../../../Pi'
import { PropertiesHelper, UserProfileConfig } from '../../../types'
import RowTableProperty from '../components/Properties/RowTableProperty.vue'
import SetUserProperty from '../components/Properties/SetUserProperty.vue'

export type TableProperty = {
  id: number
  type: PropertyFieldType
  name: string
  options: Array<any> | null
  value: string | number | boolean | Array<string>
  propType: string
}

@Component({
  components: {
    RowTableProperty,
    SetUserProperty,
  },
  data() {
    return {
      isPropertyEditable
    }
  }
})
export default class ProfileProperties extends UseFields {
  @VModel() profile!: UserProfile

  @Prop() helper!: PropertiesHelper

  @Prop() mediaTargetId!: UserProfileConfig['mediaTargetId']

  isOpen = false

  selectedProperty: TableProperty | null = null

  updating = false

  get properties(): UserProfileProperties {
    return this.profile.properties
  }

  get existProperties(): Array<number> {
    return [
      ...this.properties.custom.map((prop) => prop.property.id),
      ...this.properties.system.map((prop) => prop.property.id),
    ]
  }

  get tableProperties(): Array<TableProperty> {
    const custom = this.properties.custom.map((property) => {
      return {
        ...property.property,
        value: property.value,
        propType: 'custom'
      }
    })

    const automaticProperties = this.helper.getProperties()
      .filter((p) => p.group === PropertyGroup.System && 'automatic' in p && p.automatic)
      .map((p) => p.id)

    const system = this.properties.system
      .filter((p) => !automaticProperties.includes(p.property.id))
      .map((property) => {
        return {
          ...property.property,
          value: property.value,
          propType: 'system'
        }
      })

    return [ ...system, ...custom ]
  }

  removePropertyHandler(id: number): void {
    this.helper.removeProperty(this.profile.user_id, id)
      .then(() => {
        const custom = this.profile!.properties.custom.findIndex((prop) => prop.property.id === id)
        const system = this.profile!.properties.system.findIndex((prop) => prop.property.id === id)

        if (custom >= 0 && system === -1) {
          this.profile!.properties.custom.splice(custom, 1)
        } else {
          this.profile!.properties.system.splice(system, 1)
        }
      })
  }

  removePropertyWarn(id: number) {
    this.$confirm({
      title: this.$t('remove_bot_user_property_warn_title').toString(),
      content: this.$t('remove_bot_user_property_warn_text').toString(),
      onOk: () => this.removePropertyHandler(id)
    })
  }

  setProperty({ id, value }: { id: number, value: string | number | boolean }): void {
    const propertyUserExist = this.profile!.properties.custom.some((prop) => prop.property.id === id) || this.profile!.properties.system.some((prop) => prop.property.id === id)

    let property: any = null
    let propertyType: keyof UserProfileProperties | null = null

    this.helper.getProperties().forEach((prop) => {
      if (prop.id === id) {
        property = prop
        propertyType = prop.group
      }
    })

    if (this.profile && property && propertyType) {
      if (propertyUserExist) {
        (this.profile.properties[propertyType] as Array<UserProfileProperty>).find((prop) => prop.property.id === id)!.value = value
      } else {
        (this.profile.properties[propertyType] as Array<UserProfileProperty>).push({
          property: {
            id: property.id,
            type: property.type,
            name: property.name,
            options: []
          },
          value: value
        })
      }
    }

    this.selectedProperty = null
  }
}
